import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {  getToolStorageList } from "../../Thunks/HeyTraderThunks";
import { ToolType } from "../../Types/HeyTraderTypes/Tools/ToolType";

interface ToolStorageSliceState {
    loader: boolean; // for refres pages and inital loadings
    toolStorages: ToolType[];
    errorDisplay: string | null;
}

// set inital valus
const initialState : ToolStorageSliceState = {
    loader: false,
    toolStorages: [],
    errorDisplay: '',

}

// set state valu for api response

const toolStorageslice = createSlice ({
    name: 'toolStorages',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getToolStorageList.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getToolStorageList.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getToolStorageList.fulfilled, (state, action: PayloadAction<ToolType[]>) => {
                    state.loader = false;
                    state.toolStorages = action.payload;
                  })
    }
})

export const {} = toolStorageslice.actions
export default toolStorageslice.reducer

